import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { JobStatus, MicrosoftProvisioningJob } from '../../shared/models/generated/ziroModels';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class MsZeroTouchProvisioningResource {
  protected _baseUrl = '/services/microsoft/automate-jobs';
  private _http = inject(HttpClient);

  getAll = (tenantId: number): Observable<MicrosoftProvisioningJob[]> => {
    return this._http.get<MicrosoftProvisioningJob[]>(`${this._baseUrl}/tenants/${tenantId}/zero-touch-provisionings`);
  };

  get = (tenantId: number, jobId: number): Observable<MicrosoftProvisioningJob> => {
    return this._http.get<MicrosoftProvisioningJob>(
      `${this._baseUrl}/tenants/${tenantId}/zero-touch-provisionings/${jobId}`,
    );
  };

  post = (tenantId: number, job: MicrosoftProvisioningJob): Observable<MicrosoftProvisioningJob> => {
    return this._http.post<MicrosoftProvisioningJob>(
      `${this._baseUrl}/tenants/${tenantId}/zero-touch-provisionings`,
      job,
    );
  };

  put = (tenantId: number, jobId: number, job: MicrosoftProvisioningJob): Observable<MicrosoftProvisioningJob> => {
    return this._http.put<MicrosoftProvisioningJob>(
      `${this._baseUrl}/tenants/${tenantId}/zero-touch-provisionings/${jobId}`,
      job,
    );
  };

  delete = (tenantId: number, jobId: number): Observable<void> => {
    return this._http.delete<void>(`${this._baseUrl}/tenants/${tenantId}/zero-touch-provisionings/${jobId}`);
  };

  runJob = (tenantId: number, jobId: number): Observable<JobStatus> => {
    return this._http.post<JobStatus>(
      `${this._baseUrl}/tenants/${tenantId}/zero-touch-provisionings/${jobId}/run`,
      null,
    );
  };
}
